import { render, staticRenderFns } from "./learner-identity-chart-line.vue?vue&type=template&id=32422eac&scoped=true&"
import script from "./learner-identity-chart-line.ts?vue&type=script&lang=ts&"
export * from "./learner-identity-chart-line.ts?vue&type=script&lang=ts&"
import style0 from "./learner-identity-chart-line.scss?vue&type=style&index=0&id=32422eac&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32422eac",
  null
  
)

export default component.exports